module.exports = __webpack_public_path__ + "static/images/icon-oreo.3b7a670cd2a4a071aa924c1c78eb1244.svg";